import React from 'react';

function CloseIcon() {
  return (
    <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Close</title>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-705.000000, -34.000000)" fill="#D7D7D6">
          <g transform="translate(716.000000, 45.000000) rotate(90.000000) translate(-716.000000, -45.000000) translate(705.000000, 34.000000)">
            <polygon points="12.5906 11 22 20.4094 20.4083 22 11 12.5906 1.5906 22 0 20.4094 9.4083 11 0 1.5906 1.5906 0 11 9.4094 20.4083 0 22 1.5906" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default CloseIcon;



// WEBPACK FOOTER //
// ./src/components/icons/CloseIcon.js